import { message } from 'antd'
import get from 'lodash.get'

const handleException = (error: Error | unknown) => {
  if (error instanceof Error) {
    message.error(error.message)
    return
  }

  message.error(get(error, 'message', 'Something went wrong!'))
}

export default handleException
